
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class OnboardingNoMFA extends Vue {
  disableMFA() {
    this.$store.dispatch('auth/disableMFAOnboarding');
  }
}
